$(document).ready(function () {
  let p = $('body').attr('p');
  let locationId =
    localStorage.getItem('mainLocationId') ?? $('body').attr('event_id');
  let trunOverExMva = 0;
  let yesterdayExVatTurnoverSum = 0;
  let isOpening = true;
  const isTablet = !!window.ReactNativeWebView;
  let refreshDataCount = 0;

  moment.tz.setDefault('Europe/Oslo');
  if (p === 'organizer_location_dashboard') {
    setDeviceId();
    function fitToViewport() {
      $('#content').height($(window).height());
    }

    fitToViewport();

    // Adjust on window resize
    $(window).resize(function () {
      fitToViewport();
    });
    moment.updateLocale('en', {
      week: {
        dow: 1, // Monday is the start of the week
      },
      weekdays: 'Søndag_Mandag_Tirsdag_Onsdag_Torsdag_Fredag_Lørdag'.split('_'),
    });

    function refreshDashboardData() {
      $('#location-dashboard-refresh-button').html(
        '<div class="loader"></div>'
      );
      $('#location-dashboard-refresh-button').attr('disabled', true);
      ajaxGetStatisticsData();
      loadPieCharts();
      loadLineCharts().always(function () {
        $('#location-dashboard-refresh-button').attr('disabled', false);
        $('#location-dashboard-refresh-button .loader').remove();
        $('#location-dashboard-refresh-button').text(
          $('#location-dashboard-refresh-button').attr('data-label')
        );
        const weekAndMonthBarChartHtml =
          '<button class="d-flex justify-content-center align-items-center my-4 space-x-2 btn btn-primary btn-primary" id="average-turnover-button"><span class="context">Prognose og gjennomsnitt</span></button>';
        $('.weekAndMonthBarChart').html(weekAndMonthBarChartHtml);
      });
    }

    function updateTime() {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const year = now.getFullYear();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      $('#last-updated-time').text(
        `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`
      );
    }

    function performRefresh() {
      refreshDashboardData();
    }

    function startRefreshing() {
      performRefresh();
    }

    $('#location-dashboard-refresh-button').on('click', startRefreshing);

    let start_date = moment().format('YYYY-MM-DD') + 'T00:00';
    let end_Date = moment().format('YYYY-MM-DD') + 'T23:59';
    let isIncludingTableTurnOver = 0;
    let isIncludingCreditOrder = 0;
    let isShowAllLocation = $('#show_all_location').is(':checked') ? 1 : 0;
    let weeks = 1;
    let months = 1;

    $(document).on('click', '#location-dashboard-turnover-sum', function (e) {
      e.preventDefault();

      window.location.href = `/location/${locationId}/statistics?filter_by=day&custom_period=time&prev_selected_period=time&start_date=${start_date}&end_date=${end_Date}`;
    });

    $(document).on('click', '#average-turnover-button', function (e) {
      e.preventDefault();
      loadAverageChartData();
    });

    const currentDay = moment().day();

    // Calculate the day of the week for last week
    const currentDayName = moment().day(currentDay).format('dddd');
    const yesterdayDayName = moment()
      .day(currentDay - 1)
      .format('dddd');

    function pieChart(container, primalData) {
      const tooltipLabelText =
        container == 'location-dashboard-pie-vat' ? 'varer' : 'ordrer';

      Highcharts.chart(container, {
        chart: {
          type: 'variablepie',
          height: isTablet ? 80 : 100,
          style: {
            width: '100%',
          },
          marginLeft: -120,
          marginRight: 5,
        },

        title: false,
        exporting: { enabled: false },
        credits: { enabled: false },
        tooltip: {
          headerFormat: '',
          pointFormat:
            '<span style="color:{point.color}">\u25CF</span> <b> {point.name}</b><br/>' +
            'Sum(eks mva): <b>{formattedY}</b><br/>' +
            'Antall ' +
            tooltipLabelText +
            ': <b>{point.z}</b><br/>',
          formatter: function () {
            const formattedY = formattedPriceToShow(this.y);
            return (
              '<span style="color:' +
              this.point.color +
              '">\u25CF</span> <b>' +
              this.point.name +
              '</b><br/>' +
              'Sum(eks mva): <b>' +
              formattedY +
              '</b><br/>' +
              'Antall ' +
              tooltipLabelText +
              ': <b>' +
              this.point.z +
              '</b><br/>'
            );
          },
          style: {
            fontSize: '11px',
            width: 100,
          },
          backgroundColor: 'rgba(255, 255, 255, 1)', // Solid white background
          borderRadius: 5, // Rounded corners
          borderWidth: 1, // Add border for better visibility
          borderColor: '#ccc', // Light gray border
          shadow: true, // Add shadow for depth
          zIndex: 9999,
          hideDelay: 50,
          positioner: function (labelWidth, labelHeight) {
            const chart = this.chart;
            const centerX = chart.plotLeft + chart.series[0].center[0]; // X-center of the pie
            const centerY = chart.plotTop + chart.series[0].center[1]; // Y-center of the pie
            const radius = chart.series[0].center[2] / 2; // Radius of the pie chart

            const tooltipX = centerX + radius + 3; // Place it to the right, just outside the pie
            const tooltipY = centerY - labelHeight / 2; // Center it vertically with the pie
            return { x: tooltipX, y: tooltipY };
          },
          borderWidth: 0,
        },
        plotOptions: {
          variablepie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false,
            },
            showInLegend: true,
            enableMouseTracking: true,
            point: {
              events: {
                mouseOver: function () {
                  // Reduce opacity of the corresponding legend item
                  const legendItems = this.series.chart.legend.allItems;
                  legendItems.forEach((item) => {
                    item.legendItem.element.style.opacity = 0;
                    item.legendItem.element.style.transition = 'opacity 0.2s';
                  });
                },
                mouseOut: function () {
                  // Restore opacity when the mouse leaves with shorter transition
                  const legendItems = this.series.chart.legend.allItems;
                  legendItems.forEach((item) => {
                    item.legendItem.element.style.transition = 'opacity 2s'; // Reduced from 0.02s to 0.01s
                    item.legendItem.element.style.opacity = 1;
                  });
                },
              },
            },
          },
        },
        series: [
          {
            minPointSize: 10,
            innerSize: '20%',
            zMin: 0,
            name: 'countries',
            data: primalData,
          },
        ],
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          floating: false,
          useHTML: true,
          labelFormatter: function () {
            return `
        <div style="text-align: left; width: 100px; word-wrap: break-word; white-space: normal;">
        ${this.name}
         </div>`;
          },
        },
      });
    }

    function eventBarChart(primalData) {
      const hours = isOpening ? primalData.date : primalData.yesterdayDate;
      const seriesDataList = isOpening
        ? primalData.revenue
        : primalData.yesterdayrevenue;
      const alignedData = seriesDataList.slice(0, hours.length);
      Highcharts.chart('event-bar-graph', {
        chart: { type: 'column', height: isTablet ? 150 : 200 },
        exporting: { enabled: false },
        title: false,
        xAxis: {
          categories: hours,
          title: {
            text: $('#admin-dashboard-bar-graph').attr('data-x-axis-text'),
          },
        },
        yAxis: {
          title: {
            text: $('#admin-dashboard-bar-graph').attr('data-y-axis-text'),
          },
        },
        credits: { enabled: false },
        series: [
          {
            showInLegend: false,
            data: alignedData,
            name: 'Omsetning ink. mva.',
          },
        ],
        plotOptions: {
          series: {},
        },
        tooltip: {
          pointFormatter: function () {
            const formattedValue = formattedPriceToShow(this.y);
            return `${this.series.name}: <b>${formattedValue}</b><br/>`;
          },
          shared: true,
        },
      });
    }

    function eventLineChart(currentData) {
      let todayTurnover = currentData.revenue.reduce(
        (acc, item) => acc + item,
        0
      );
      let yesterdayTurnover = currentData.yesterdayrevenue.reduce(
        (acc, item) => acc + item,
        0
      );

      Highcharts.chart('event-line-graph', {
        chart: { height: isTablet ? 150 : 200, marginBottom: 70 },
        exporting: { enabled: false },
        title: false,
        plotOptions: {
          series: {},
        },
        xAxis: {
          categories: isOpening ? currentData.date : currentData.yesterdayDate,
          labels: {
            rotation: 0, // Setting X-axis label rotation to 0 degrees
          },
        },
        yAxis: {
          title: {
            text: $('#admin-dashboard-line-graph').attr('data-y-axis-text'),
          },
        },
        credits: { enabled: false },
        series: [
          {
            name: isOpening
              ? `Omsetning i dag (NOK ${formattedPriceToShow(
                  floor(todayTurnover)
                )} inkl mva) `
              : 'Omsetning i går (NOK ' +
                formattedPriceToShow(floor(yesterdayTurnover)) +
                ' inkl mva)',
            data: isOpening
              ? currentData.revenue
              : currentData.yesterdayrevenue,
            color: '#2EADF4',
          },
          {
            name: isOpening
              ? `Omsetning forrige ${currentDayName} (NOK ${formattedPriceToShow(
                  floor(currentData.lastWeekDateTurnover)
                )} inkl mva)`
              : `Omsetning forrige ${yesterdayDayName} (NOK ${formattedPriceToShow(
                  floor(currentData.yesterdaylastWeekDateTurnover)
                )} inkl mva)`,
            data: isOpening
              ? currentData.lastWeekDaterevenue
              : currentData.yesterdaylastWeekDaterevenue,
            color: '#D3D3D3',
          },
        ],
        tooltip: {
          pointFormatter: function () {
            const formattedValue = formattedPriceToShow(this.y);
            return `${this.series.name}: <b>${formattedValue}</b><br/>`;
          },
          shared: true,
        },
      });
    }

    function columnChart(
      currentWeeklyTotalTurnOver,
      previousWeeklyTotalTurnOver,
      avrageWeeklyTotalTurnOver,
      currentMonthTotalTurnover,
      previousMonthTotalTurnover,
      averageMonthTotalTurnover,
      weeklySalePrediction,
      monthlySalePrediction,
      weekCount,
      monthCount
    ) {
      let biggestValue = Math.max(
        currentWeeklyTotalTurnOver,
        previousWeeklyTotalTurnOver,
        avrageWeeklyTotalTurnOver,
        currentMonthTotalTurnover,
        previousMonthTotalTurnover,
        averageMonthTotalTurnover
      );

      let firstDateOfMonth =
        moment().startOf('month').format('YYYY-MM-DD') + 'T00:00';
      let lastDateOfMonth =
        moment().endOf('month').format('YYYY-MM-DD') + 'T23:59';
      let firstDateOfWeek =
        moment().startOf('week').format('YYYY-MM-DD') + 'T00:00';
      let lastDateOfWeek =
        moment().endOf('week').format('YYYY-MM-DD') + 'T23:59';

      Highcharts.chart('bar-chart', {
        chart: { type: 'column', height: 150 },
        exporting: { enabled: false },
        title: false,
        xAxis: {
          categories: ['UKE', 'MND'],
          title: {
            text: $('#admin-dashboard-bar-graph').attr('data-x-axis-text'),
          },
        },
        yAxis: {
          min: 0,
          max: biggestValue,
          endOnTick: false,
          title: false,
          labels: {
            formatter: function () {
              if (this.value >= 1000) {
                return (this.value / 1000).toFixed(0) + 'k';
              }
              return this.value;
            },
          },
        },
        credits: { enabled: false },
        plotOptions: {
          column: {
            pointWidth: 20,
            events: {
              click: function (event) {
                let clickedColumnData =
                  event.point.series.data[event.point.index];

                window.location.href = `/location/${locationId}/statistics?filter_by=${
                  clickedColumnData.category == 'UKE' ? 'week' : 'month'
                }&custom_period="day"&prev_selected_period=${
                  clickedColumnData.category == 'UKE' ? 'week' : 'month'
                }&start_date=${
                  clickedColumnData.category == 'UKE'
                    ? firstDateOfWeek
                    : firstDateOfMonth
                }&end_date=${
                  clickedColumnData.category == 'UKE'
                    ? lastDateOfWeek
                    : lastDateOfMonth
                }`;
              },
            },
          },
          series: {},
        },
        series: [
          {
            showInLegend: false,
            data: [currentWeeklyTotalTurnOver, currentMonthTotalTurnover],
            name: 'Denne',
          },
          {
            showInLegend: false,
            data: [previousWeeklyTotalTurnOver, previousMonthTotalTurnover],
            name: 'Forrige',
          },
          {
            showInLegend: false,
            data: [avrageWeeklyTotalTurnOver, averageMonthTotalTurnover],
            name: 'Gjennomsnitts',
          },
        ],
        tooltip: {
          formatter: function () {
            if (this.series.name === 'Gjennomsnitts') {
              return (
                (this.point.category === 'UKE'
                  ? `Siste ${weekCount} uker gjennomsnitt : `
                  : `Siste ${monthCount} måneder gjennomsnitt : `) +
                formattedPriceToShow(this.y)
              );
            } else {
              return (
                this.series.name +
                ' ' +
                (this.point.category === 'UKE' ? 'uke' : 'måned') +
                ' : ' +
                `<b>${formattedPriceToShow(this.y)}</b>${
                  weeklySalePrediction &&
                  this.series.name === 'Denne' &&
                  this.point.category === 'UKE'
                    ? `<br/>Prognose : <b>${formattedPriceToShow(
                        weeklySalePrediction
                      )}</b>`
                    : ''
                }${
                  monthlySalePrediction &&
                  this.series.name === 'Denne' &&
                  this.point.category === 'MND'
                    ? `<br/>Prognose : <b>${formattedPriceToShow(
                        monthlySalePrediction
                      )}</b>`
                    : ''
                }`
              );
            }
          },
        },
      });
    }

    $(document).on('show.bs.collapse', '#checkboxContainer', function () {
      $('[data-target="#checkboxContainer"] .rotate-icon').addClass('rotated');
    });
    $(document).on('hide.bs.collapse', '#checkboxContainer', function () {
      $('[data-target="#checkboxContainer"] .rotate-icon').removeClass(
        'rotated'
      );
    });

    $(document).on('change', '#include_table_turnover', function () {
      isIncludingTableTurnOver = $(this).is(':checked') ? 1 : 0;
      ajaxGetStatisticsData();
      loadPieCharts();
      loadLineCharts();
    });
    $(document).on('change', '#included_credit_order', function () {
      isIncludingCreditOrder = $(this).is(':checked') ? 1 : 0;
      ajaxGetStatisticsData();
      loadPieCharts();
      loadLineCharts();
    });
    $(document).on('change', '#show_all_location', function () {
      isShowAllLocation = $(this).is(':checked') ? 1 : 0;
      ajaxGetStatisticsData();
      loadPieCharts();
      loadLineCharts();
    });

    function ajaxGetStatisticsData() {
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_location_dashboard/get_statistic',
        data: {
          location_id: locationId,
          isIncludingTableTurnOver,
          isIncludingCreditOrder,
          isShowAllLocation,
        },
      })
        .done(function (data) {
          let currentTime = moment().valueOf();
          trunOverExMva = 0;
          if (data) {
            const openingTime = moment(
              data.start_date,
              'YYYY-MM-DD HH:mm:ss'
            ).valueOf();

            isOpening = currentTime > openingTime;
          }

          if (parseFloat(data.ex_vat_turnover_sum) > 0) {
            trunOverExMva = parseFloat(data.ex_vat_turnover_sum);
          }

          if (parseFloat(data.yesterday_ex_vat_turnover_sum) > 0) {
            yesterdayExVatTurnoverSum = parseFloat(
              data.yesterday_ex_vat_turnover_sum
            );
          }

          let formatedTurnover = formatNumberForTotal(data.turnover_sum);

          //daily turnover
          if (!isOpening) {
            $('#turnover-title').text('Omsetning i går').fadeIn(400);
            $('#include_table_turnover_label').addClass('d-none');
          } else {
            $('#include_table_turnover_label').removeClass('d-none');
          }
          $('#location-dashboard-turnover-sum #turnover-title-period')
            .text(isOpening ? data.period_label : data.yesterday_period_label)
            .fadeIn(400);
          $('#location-dashboard-turnover-sum #turnover-sum')
            .hide()
            .text(
              isOpening
                ? formatedTurnover
                : formatNumberForTotal(data.yesterday_turnover_sum)
            )
            .fadeIn(400);

          $('#location-dashboard-turnover-sum #turnover-sum-ex-vat')
            .hide()
            .html(
              formatNumberForTotal(
                isOpening
                  ? trunOverExMva +
                      (isIncludingTableTurnOver
                        ? data.turnover_ex_vat_from_prodcut_table
                        : 0)
                  : yesterdayExVatTurnoverSum
              ) +
                ' ' +
                'eks mva'
            )
            .fadeIn(400);

          eventBarChart(data);
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        })
        .always(function () {
          refreshDataCount++;
          if (refreshDataCount >= 4) {
            refreshDataCount = 0;
            updateTime();
            $('#location-dashboard-refresh-button').attr('disabled', false);
            $('#location-dashboard-refresh-button .loader').remove();
            $('#location-dashboard-refresh-button').text(
              $('#location-dashboard-refresh-button').attr('data-label')
            );
          }
        });
    }

    function loadLineCharts() {
      return $.ajax({
        type: 'POST',
        url: '/api/v1/private/statistics/get-line-chart-data',
        data: {
          location_id: locationId,
          isIncludingTableTurnOver: isIncludingTableTurnOver,
          isIncludingCreditOrder: isIncludingCreditOrder,
          isShowAllLocation: isShowAllLocation,
        },
      })
        .done(function (data) {
          let currentTime = moment().valueOf();
          if (data) {
            const openingTime = moment(
              data.start_date,
              'YYYY-MM-DD HH:mm:ss'
            ).valueOf();

            isOpening = currentTime > openingTime;
          }

          eventLineChart(data);
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        })
        .always(function () {
          refreshDataCount++;
          if (refreshDataCount >= 4) {
            refreshDataCount = 0;
            updateTime();
            $('#location-dashboard-refresh-button').attr('disabled', false);
            $('#location-dashboard-refresh-button .loader').remove();
            $('#location-dashboard-refresh-button').text(
              $('#location-dashboard-refresh-button').attr('data-label')
            );
          }
        });
    }

    function loadPieCharts() {
      $.ajax({
        type: 'POST',
        url: '/api/v1/private/statistics/get-pie-chart-data',
        data: {
          location_id: locationId,
          isIncludingTableTurnOver: isIncludingTableTurnOver,
          isIncludingCreditOrder: isIncludingCreditOrder,
          isShowAllLocation: isShowAllLocation,
        },
      })
        .done(function (data) {
          let currentTime = moment().valueOf();
          if (data) {
            const openingTime = moment(
              data.start_date,
              'YYYY-MM-DD HH:mm:ss'
            ).valueOf();

            isOpening = currentTime > openingTime;
          }
          pieChart(
            'location-dashboard-pie-vat',
            isOpening ? data.pie_vat_data : data.pie_vat_data_of_yesterday
          );
          pieChart(
            'location-dashboard-pie-payment-option',
            isOpening
              ? data.pie_payment_option_data
              : data.pie_payment_option_data_of_yesterday
          );
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        })
        .always(function () {
          refreshDataCount++;
          if (refreshDataCount >= 4) {
            refreshDataCount = 0;
            updateTime();
            $('#location-dashboard-refresh-button').attr('disabled', false);
            $('#location-dashboard-refresh-button .loader').remove();
            $('#location-dashboard-refresh-button').text(
              $('#location-dashboard-refresh-button').attr('data-label')
            );
          }
        });
    }

    function loadAverageChartData() {
      const container = $('#bar-chart');

      let firstDateOfMonth =
        moment().startOf('month').format('YYYY-MM-DD') + 'T00:00';
      let lastDateOfMonth =
        moment().endOf('month').format('YYYY-MM-DD') + 'T23:59';
      let firstDateOfWeek =
        moment().startOf('week').format('YYYY-MM-DD') + 'T00:00';
      let lastDateOfWeek =
        moment().endOf('week').format('YYYY-MM-DD') + 'T23:59';

      const chart = Highcharts.chart('bar-chart', {
        chart: { type: 'column', height: 150 },
        exporting: { enabled: false },
        title: false,
        xAxis: {
          categories: ['UKE', 'MND'],
          title: {
            text: $('#admin-dashboard-bar-graph').attr('data-x-axis-text'),
          },
        },
        yAxis: {
          min: 0,
          max: 0,
          endOnTick: false,
          title: false,
          labels: {
            formatter: function () {
              if (this.value >= 1000) {
                return (this.value / 1000).toFixed(0) + 'k';
              }
              return this.value;
            },
          },
        },
        credits: { enabled: false },
        plotOptions: {
          column: {
            pointWidth: 20,
            events: {
              click: function (event) {
                let clickedColumnData =
                  event.point.series.data[event.point.index];

                window.location.href = `/location/${locationId}/statistics?filter_by=${
                  clickedColumnData.category == 'UKE' ? 'week' : 'month'
                }&custom_period="day"&prev_selected_period=${
                  clickedColumnData.category == 'UKE' ? 'week' : 'month'
                }&start_date=${
                  clickedColumnData.category == 'UKE'
                    ? firstDateOfWeek
                    : firstDateOfMonth
                }&end_date=${
                  clickedColumnData.category == 'UKE'
                    ? lastDateOfWeek
                    : lastDateOfMonth
                }`;
              },
            },
          },
        },
        series: [
          {
            showInLegend: false,
            data: [0, 0],
            name: 'Denne',
          },
          {
            showInLegend: false,
            data: [0, 0],
            name: 'Forrige',
          },
          {
            showInLegend: false,
            data: [0, 0],
            name: 'Gjennomsnitts',
          },
        ],
      });

      chart.showLoading();

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/statistics/get-average',
        data: {
          location_id: locationId,
          isIncludingTableTurnOver: isIncludingTableTurnOver,
          isIncludingCreditOrder: isIncludingCreditOrder,
          isShowAllLocation: isShowAllLocation,
        },
      })
        .done(function (data) {
          let currentWeeklyTotalTurnOver = 0;
          let previousWeeklyTotalTurnOver = 0;
          let avrageWeeklyTotalTurnOver = 0;
          let currentMonthTotalTurnover = 0;
          let previousMonthTotalTurnover = 0;
          let averageMonthTotalTurnover = 0;

          if (data) {
            container.empty();
            currentWeeklyTotalTurnOver = parseFloat(
              data.currentWeeklyTotalTurnOver
            );
            previousWeeklyTotalTurnOver = parseFloat(
              data.previousWeeklyTotalTurnOver
            );

            currentMonthTotalTurnover = parseFloat(
              data.currentMonthTotalTurnover
            );
            previousMonthTotalTurnover = parseFloat(
              data.previousMonthTotalTurnover
            );

            avrageWeeklyTotalTurnOver = parseFloat(
              data.averageWeeklyTotalTurnover
            );
            averageMonthTotalTurnover = parseFloat(
              data.averageMonthlyTotalTurnover
            );

            columnChart(
              currentWeeklyTotalTurnOver,
              previousWeeklyTotalTurnOver,
              avrageWeeklyTotalTurnOver,
              currentMonthTotalTurnover,
              previousMonthTotalTurnover,
              averageMonthTotalTurnover,
              data.weekly_sale_prediction ? data.weekly_sale_prediction : null,
              data.monthly_sale_prediction
                ? data.monthly_sale_prediction
                : null,
              data.weekCount,
              data.monthCount
            );
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
          chart.hideLoading();
          columnChart(0, 0, 0, 0, 0, 0, 0, 0);
        })
        .always(function () {
          refreshDataCount++;
          if (refreshDataCount >= 4) {
            refreshDataCount = 0;
            updateTime();
            $('#location-dashboard-refresh-button').attr('disabled', false);
            $('#location-dashboard-refresh-button .loader').remove();
            $('#location-dashboard-refresh-button').text(
              $('#location-dashboard-refresh-button').attr('data-label')
            );
          }
        });
    }

    function formatNumberForTotal(number) {
      // Convert input to string and clean spaces
      number = String(number).trim();

      // Check if valid number
      if (isNaN(number) || number === '') {
        return '-';
      }

      // Split integer and decimal parts
      let parts = number.split('.');
      let integerPart = parts[0];
      let decimalPart = parts[1] || '';

      // Add thousand separators (dot)
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

      // If there’s no decimal part, show ",-"
      if (decimalPart === '') {
        return integerPart + ',-';
      }

      // Keep only two decimals without rounding
      decimalPart = decimalPart.substring(0, 2);

      // Pad if only one decimal digit
      if (decimalPart.length === 1) {
        decimalPart += '0';
      }

      // Combine integer and decimal with comma
      return integerPart + ',' + decimalPart;
    }

    ajaxGetStatisticsData();
    loadPieCharts();
    loadLineCharts();
  }
});
